import React, { FunctionComponent, useRef } from 'react'
import { Field } from '../../../types/Form/IForm'
import { DatePicker, DateTimePicker } from "@progress/kendo-react-dateinputs";
import { FieldRenderProps } from '@progress/kendo-react-form';

export const DateField: FunctionComponent<FieldRenderProps> = props => {
  const { field, value, ...others } = props;
  const defVal = field?.VALUES?.length > 0 ? new Date(field?.VALUES[0]) : undefined //props.ConfigSettings?.Default === "2" ? new Date(Date.parse(props.ConfigSettings?.DefaultValue)) : (props.ConfigSettings?.Default === "1" ? new Date() : null);
  const wrapper = useRef();
  const onBlur = (e) => {
    let fieldChange = { ...field, VALUES: [e.target.value] }
    props.onChange({ value: fieldChange });
  }
  // defaultValue={defVal}
  if (field.ConfigSettings?.Display === "1")
    return <DateTimePicker {...others} onBlur={onBlur} />
  else
    return (
      <div ref={wrapper}>
        {/* {JSON.stringify(defVal)} */}
        <DatePicker {...others} popupSettings={{ appendTo: wrapper.current, popupClass: 'z500' }} onBlur={onBlur} />
      </div>

    )

}
